import React from "react";
import { defaultStyle } from "./style";
import { css } from "emotion";
import { Card as AtomicCard } from "@maxmilhas/hangar-components-atomic/public";
import theme from "../../../js/shared/new-theme"

const Card = props => {
    const colorToUse = theme.palette[props.color]
        ? theme.palette[props.color][500].value
        : props.color || theme.palette.gray[400].value;
    const cardStyles = defaultStyle(props.type, props.hasError, props.statusIcon, props.subtitle);
    return (
        <div
            className={css`
				${cardStyles}
			`}
        >
            <AtomicCard {...props} titleColor={colorToUse} />
        </div>
    );
};

export default Card;
